import { Navigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { authAPI } from '../services/api'
import { setAdminSession, clearAdminSession } from '../utils/auth'

function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    checkAuth()
  }, [])

  const checkAuth = async () => {
    let authed = false

    try {
      const response = await authAPI.check()
      if (response.success && response.data?.authenticated) {
        setAdminSession(response.data?.user?.username)
        authed = true
      }
    } catch (err) {
      // stay unauthenticated
    }

    if (!authed) {
      clearAdminSession()
    }

    setIsAuthenticated(authed)
    setLoading(false)
  }

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
          fontSize: '18px',
        }}
      >
        Checking authentication...
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/vedantlights/login" replace />
  }

  return children
}

export default ProtectedRoute
